export const isInternal = (href: string) => /^(\/|#)(?!\/)/.test(href);
